export enum TextingCandidateConsentStatus {
  Given = 'given',
  NoConsent = 'no_consent',
}

export enum TextingCandidateConsentSource {
  CarrierSite = 'careers_site',
  Admin = 'admin',
  Sms = 'sms',
}

export enum TextingCandidateMessageAspect {
  Sent = 'sent',
  Received = 'received',
}

export enum TextingCandidateMessageStatus {
  Created = 'created',
  Accepted = 'accepted',
  Queued = 'queued',
  Sending = 'sending',
  Delivered = 'delivered',
  Sent = 'sent',
  Failed = 'failed',
  Undelivered = 'undelivered',
  Scheduled = 'scheduled',
}

export enum CampaignRequestStatus {
  Requested = 'requested',
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Deleted = 'deleted',
}
